import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/lib/apiClient";
import type { MessageMonitorResponse } from "@/types/messageMonitor";

// ─── Query keys ────────────────────────────────────────────────────────────────

export const messageMonitorKeys = {
  byRange: (startDate: string, endDate: string) =>
    ["message-monitor", startDate, endDate] as const
};

// ─── Queries ──────────────────────────────────────────────────────────────────

/**
 * Fetches messages for the given ISO date range.
 * Mirrors MessageMonitorService.GetMessagesByDateRangeAsync → GET /MessageMonitor?startDate=&endDate=
 */
export function useMessageMonitor(startDate: string, endDate: string) {
  return useQuery({
    queryKey: messageMonitorKeys.byRange(startDate, endDate),
    queryFn: () =>
      apiFetch<MessageMonitorResponse[]>(
        `MessageMonitor?startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}`
      ),
    enabled: !!startDate && !!endDate && startDate <= endDate,
    staleTime: 30_000
  });
}
